import { render, staticRenderFns } from "./UserRankSelect.vue?vue&type=template&id=0a9df854&"
import script from "./UserRankSelect.vue?vue&type=script&lang=js&"
export * from "./UserRankSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports